import { i18n } from '@fs/zion-locale'

export default {
  advancedSearch: () => i18n.t('searchForm.advancedSearch', 'Advanced Search'),
  searchImageGroups: () => i18n.t('searchForm.surnameSearchBtnTitle', 'Search'),
}
